import { Schema } from "effect";

/** `redis` is XADD'd straight to a Redis stream; `notice` goes through the notice server. */
export const StreamTestTransport = Schema.Literal("redis", "notice");
export type StreamTestTransport = typeof StreamTestTransport.Type;

export const PublishStreamTestEventInput = Schema.Struct({
  /** Client-generated so the tester can correlate sent against received. */
  eventId: Schema.String.pipe(Schema.minLength(1), Schema.maxLength(128)),
  note: Schema.String.pipe(Schema.maxLength(512)),
});
export type PublishStreamTestEventInput =
  typeof PublishStreamTestEventInput.Type;

/** Per-transport result: a whole-request failure would hide the signal we want. */
export const StreamTestPublishResult = Schema.Struct({
  transport: StreamTestTransport,
  ok: Schema.Boolean,
  error: Schema.optional(Schema.String),
});
export type StreamTestPublishResult = typeof StreamTestPublishResult.Type;

export const PublishStreamTestEventResponse = Schema.Struct({
  eventId: Schema.String,
  publishedAt: Schema.Number,
  results: Schema.Array(StreamTestPublishResult),
});
export type PublishStreamTestEventResponse =
  typeof PublishStreamTestEventResponse.Type;
